'use client';

import { useLayoutEffect, useRef } from 'react';
import StepperProgressBar from '@/components/stepper/stepper-progressbar';
import StepperStep from '@/components/stepper/stepper-step';
import { useAuthStore } from '@/stores/authStore';
import { useWizardStore } from '@/stores/wizardStore';

export default function StepperSteps() {
  const steps = useWizardStore((s) => s.steps);
  const currentStep = useWizardStore((s) => s.currentStep);
  const setStepsGap = useWizardStore((s) => s.setStepsGap);
  const stepsGap = useWizardStore((s) => s.stepsGap);
  const isLoading = useAuthStore((s) => s.isLoading);

  const stepsRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    // Wait for loading to complete before calculating
    if (isLoading) return;

    // Only calculate gap if it hasn't been set yet
    if (stepsRef.current && !stepsGap) {
      const computedStyle = window.getComputedStyle(stepsRef.current);
      const gap = parseInt(computedStyle.gap, 10);
      setStepsGap(gap);
    }
  }, [setStepsGap, stepsGap, isLoading]);

  // Don't render steps while loading
  if (isLoading) return null;

  return (
    <div className="relative mx-auto mb-8 flex w-full flex-col items-center sm:mb-12">
      <StepperProgressBar />
      <div
        ref={stepsRef}
        className="xs:gap-[46px] relative mt-8 flex justify-center gap-5"
        style={{ width: 'fit-content' }}
      >
        {steps.map((step, idx) => (
          <StepperStep
            key={step.title}
            title={step.title}
            index={idx}
            isCompleted={idx < currentStep}
            isActive={idx === currentStep}
          />
        ))}
      </div>
    </div>
  );
}
